const reportOne               = require('./item-report-one')
const reportItemAvailable     = require('./item-report-item-available')
const reportItemQuantity      = require('./item-report-item-quantity')

export function start(detail) {  //console.log('goku-dt 5>', detail)

      obj[detail.reportType].start(detail)

}/**/

const obj = {

      reportOne:              { start: (detail) => { reportOne.start(detail)              } },
      reportItemAvailable:    { start: (detail) => { reportItemAvailable.start(detail)    } },
      reportItemQuantity:     { start: (detail) => { reportItemQuantity.start(detail)     } },
}